const { HMSNewsletterSignup } = require('./newsletterSignup');

/**
 * @class NewsletterSignupPopupAutoOpen
 */
window.HMSNewsletterSignupPopupAutoOpen = class NewsletterSignupPopupAutoOpen {
	constructor() {
		this.defaultInterval = 10;
		if (this.isOnPage() && !HMSNewsletterSignup.isCookieAccepted()) {
			this.openPopupAfterInterval();
		}
	}

	isOnPage() {
		return $('#newsletter-signup-popup').length !== 0;
	}

	/**
	 * Opens Newsletter Signup Popup after interval in seconds. Default interval is 5sec.
	 * @param {Number} interval - Interval in seconds
	 */
	openPopupAfterInterval() {
		const interval = window.HMSNewsletterSignupPopupInterval || this.defaultInterval;

		setTimeout(() => {
			$.magnificPopup.open({
				items: {
					src: '#newsletter-signup-popup'
				},
        focus: '.mfp-close',
				type: 'inline',
        callbacks: {
          open: () => {
            const $newsletterPopup = $('#newsletter-signup-popup');
            const dataLabelValue = $newsletterPopup.attr('data-aria-label') || '';

            $newsletterPopup.find('.mfp-close').attr('tabindex', '1');
            $newsletterPopup.find('.mfp-close').attr('aria-label', dataLabelValue);
          }
        }
			});
		}, interval * 1000);
	}
}
